@use "../../../../shared/scss" as *;

:host {
  display: block;
  padding-inline: 10%;
  padding-block-start: p-px-to-rem(14px);

  @include pds-media-query-max("s") {
    padding-inline: p-px-to-rem(27px);
  }

  &.skeleton {
    pointer-events: none;
    user-select: none;

    & .skeleton-headline {
      inline-size: auto;
      block-size: p-px-to-rem(50px);
      background: $pds-theme-light-contrast-low;
      margin-block-end: p-px-to-rem(28px);
      border-radius: 4px;
    }
    & .map-link-container:not(.no-margin) {
      display: none;
    }
  }

  phn-nd-headline {
    margin-block-end: p-px-to-rem(36px);
  }

  .results-spinner {
    display: flex;
    justify-content: center;
    margin-block-start: $pds-spacing-fluid-medium;
  }

  .map-link-container {
    animation: fadeInFromTop 0.75s ease-in-out 0s;
    display: inline-block;
    position: relative;
    inline-size: 100%;
    margin-block-start: $pds-spacing-fluid-medium;
    &.no-margin {
      margin-block: 0;
      margin-inline: 0;
    }
    .map-link {
      background-color: $pds-theme-light-background-frosted;
      box-sizing: border-box;
      color: $pds-theme-light-primary;
      display: flex;
      font-family: $pds-font-family;
      font-size: $pds-font-size-text-small;
      font-weight: $pds-font-weight-regular;
      justify-content: space-between;
      padding-block: 26px;
      padding-inline: 10px !important;
      text-decoration-color: transparent;
      inline-size: 100%;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;

      @include pds-focus("none");
      @include pds-hover();

      phn-p-icon {
        margin-block: auto;
        margin-inline: 0;
      }
    }
  }
}
